import {  NgModule } from '@angular/core';
import { CommonModule }        from '@angular/common';
import { ModuleWithProviders } from '@angular/compiler/src/core';
import {ServicioGlobalService} from './service_global.service'


@NgModule({
  imports:      [ CommonModule ],
  declarations: [],
  exports:      [ CommonModule ]
})
export class SharedComunModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: SharedComunModule,
      providers: [ ServicioGlobalService ]                       //<<<====here
    };
  }
}